export const SET_COMMUNITY_TYPE = 'SET_COMMUNITY_TYPE';
export const SET_COMMUNITY_FILTER_TYPE = 'SET_COMMUNITY_FILTER_TYPE';
export const SET_COMMUNITY_POSTING_ID = 'SET_COMMUNITY_POSTING_ID';

export const setCommunityType = (communityType) => ({
  type: SET_COMMUNITY_TYPE,
  payload: {
    communityType
  }
});

export const setCommunityFilterType = (community) => ({
  type: SET_COMMUNITY_FILTER_TYPE,
  payload: {
    communityFilter: community
  }
});

export const setCommunityPostingId = (communityKey) => ({
  type: SET_COMMUNITY_POSTING_ID,
  payload: {
    communityPostId: communityKey
  }
});
